import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PvRecruitmentService} from '../../pv-recruitment.service';

declare let initCookieConsent: any;

@Component({
    selector: 'pv-pv-recruitment-common-footer',
    templateUrl: './pv-recruitment-common-footer.component.html',
    styleUrls: ['./pv-recruitment-common-footer.component.scss'],
    standalone: false
})
export class PvRecruitmentCommonFooterComponent implements OnInit {
  public cookieConsent: any;
  public rate: string;
  public reviewsCount: string;

  constructor(private route: ActivatedRoute,
              private recruitmentService: PvRecruitmentService) { }

  ngOnInit(): void {
    this.initializeCookieConsent();

    setTimeout(() => {
      this.route.queryParams.subscribe(params => {
        if (params.showPreferences) {
          this.openCookieSettings();
        }
      });
    }, 1000)

    this.recruitmentService.getReviewsGlobalRate().then(res => {
      const rawRate = res.reviewsGlobalRate?.rate;
      const rawCount = res.reviewsGlobalRate?.reviewsCount;

      this.rate = Number.isInteger(rawRate)
        ? rawRate.toString()
        : rawRate.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

      this.reviewsCount = rawCount.toLocaleString('fr-FR');
    })
  }

  initializeCookieConsent(): void {
    this.cookieConsent = initCookieConsent();
  }

  openCookieSettings(): void {
    if (this.cookieConsent) {
      this.cookieConsent.showSettings();
    } else {
      console.error('Cookie Consent n\'est pas encore chargé !');
    }
  }
}
